import React from "react";
import { StyleSheet, View } from "react-native";

const VerticalCenter = ({ children }) => {
  return <View style={styles.container}>{children}</View>;
};

const styles = StyleSheet.create({
  container: {
    height: "100%",
    flexDirection: "column",
    justifyContent: "center",
  },
});

export default VerticalCenter;
